import axios from 'axios';


type PermissionsApiResponse = {
    status: 'active' | 'pause' | 'unregister' | 'unpaid';
    permissions: {
        view: boolean;
        edit: boolean;
        create: boolean;
    };
};

export type Permissions = {
    status: 'active' | 'pause' | 'unregister' | 'unpaid';
    view: boolean;
    edit: boolean;
    create: boolean;
};


export async function getPermissions(): Promise<Permissions> {
    try {
        const { data: { status, permissions } } = await axios.get<PermissionsApiResponse>(
            `${window.location.origin}/api/map/permissions`,
        );
        return {
            status,
            ...permissions,
        };
    } catch (e) {
        throw e;
    };
};
